// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkAssignPreview-module__overlay___J_azi {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.BulkAssignPreview-module__card___ZU7Xa {
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.BulkAssignPreview-module__header___mjpkH {
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
}

.BulkAssignPreview-module__headerLeft___q8Qqi {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.BulkAssignPreview-module__windowToggle___zl3i4 {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BulkAssignPreview-module__windowToggleBtn___Ww38L {
  font-size: 13px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 4px;
  border: 1px solid transparent;
  background: #f9fafb;
  color: #6b7280;
  cursor: pointer;
  white-space: nowrap;
}

.BulkAssignPreview-module__windowToggleBtn___Ww38L:hover {
  color: #111827;
}

.BulkAssignPreview-module__windowToggleBtnActive___qPc2I {
  background: #ffffff;
  color: #111827;
  border-color: #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.BulkAssignPreview-module__title___BaROp {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.BulkAssignPreview-module__subtitle___tjbtE {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
}

.BulkAssignPreview-module__subtitleMuted___gpiEA {
  color: #9ca3af;
}

.BulkAssignPreview-module__rebalanceButton___Z9DJ9 {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.BulkAssignPreview-module__rebalanceButton___Z9DJ9:hover:not(:disabled) {
  background: #f3f4f6;
}

.BulkAssignPreview-module__rebalanceButton___Z9DJ9:disabled {
  opacity: 0.4;
  cursor: default;
}

.BulkAssignPreview-module__rebalanceIcon___sdFjW {
  width: 12px;
  height: 12px;
}

/* Scrollable body */
.BulkAssignPreview-module__body___JzLcQ {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

/* Section label */
.BulkAssignPreview-module__sectionLabel___E3UBS {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
}

/* Workload bars */
.BulkAssignPreview-module__workloadSection___PlhlF {
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
}

.BulkAssignPreview-module__workloadHeader___VKeRe {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.BulkAssignPreview-module__workloadHeaderLeft___Vb3K5 {
  display: flex;
  align-items: center;
  gap: 10px;
}

.BulkAssignPreview-module__workloadBudgetLabel___pvdmv {
  font-size: 10px;
  font-family: monospace;
  color: #9ca3af;
}

.BulkAssignPreview-module__workloadBadges___Tu4Aw {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BulkAssignPreview-module__overCapBadge___JkGz4 {
  font-size: 11px;
  font-weight: 600;
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 4px;
  padding: 2px 7px;
}

.BulkAssignPreview-module__slaBadge___lK04Z {
  font-size: 11px;
  font-weight: 600;
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 2px 7px;
}

.BulkAssignPreview-module__workloadList___KCNqU {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.BulkAssignPreview-module__workloadRow___IE5Dx {
  display: flex;
  align-items: center;
  gap: 12px;
}

.BulkAssignPreview-module__workloadStaff___D3Jq8 {
  width: 160px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.BulkAssignPreview-module__workloadAvatar___oHjoJ {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  flex-shrink: 0;
}

.BulkAssignPreview-module__workloadStaffInfo___VvEh1 {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.BulkAssignPreview-module__workloadStaffName___neinv {
  font-size: 12px;
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.BulkAssignPreview-module__workloadStaffRole___PiGmv {
  font-size: 10px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.BulkAssignPreview-module__workloadInlineBadges___GuxkL {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
}

.BulkAssignPreview-module__workloadInlineBadges___GuxkL .BulkAssignPreview-module__overCapBadge___JkGz4,
.BulkAssignPreview-module__workloadInlineBadges___GuxkL .BulkAssignPreview-module__slaBadge___lK04Z {
  font-size: 9px;
  padding: 1px 5px;
}

.BulkAssignPreview-module__workloadBarWrap___FTTVc {
  flex: 1;
  height: 18px;
  background: #f3f4f6;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  position: relative;
}

.BulkAssignPreview-module__workloadBarCurrent___JLv2W {
  height: 100%;
  background: #d1d5db;
  flex-shrink: 0;
}

.BulkAssignPreview-module__workloadBarDelta___BtFFm {
  height: 100%;
  background: #18181b;
  flex-shrink: 0;
}

.BulkAssignPreview-module__workloadBarDeltaOver___kh953 {
  height: 100%;
  background: #d97706;
  flex-shrink: 0;
}

.BulkAssignPreview-module__workloadBarDeltaSla___QsOPM {
  height: 100%;
  background: #b91c1c;
  flex-shrink: 0;
}

.BulkAssignPreview-module__workloadCapacityMarker___a9DgA {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(107, 114, 128, 0.5);
}

.BulkAssignPreview-module__workloadNumbers___USvrx {
  width: 100px;
  flex-shrink: 0;
  text-align: right;
  font-size: 11px;
  font-family: monospace;
  line-height: 1.4;
}

.BulkAssignPreview-module__workloadUtilPct___jPXuu {
  font-size: 10px;
  color: #9ca3af;
}

.BulkAssignPreview-module__workloadNum___rk388 {
  color: #6b7280;
}

.BulkAssignPreview-module__workloadNumOver___egiDL {
  color: #92400e;
  font-weight: 600;
}

.BulkAssignPreview-module__workloadNumSla___HdgDt {
  color: #b91c1c;
  font-weight: 600;
}

.BulkAssignPreview-module__workloadNumDelta___egR4y {
  color: #18181b;
  font-weight: 600;
}

/* Assignments section */
.BulkAssignPreview-module__assignSection___RYycu {
  padding: 14px 20px 8px;
}

.BulkAssignPreview-module__assignSectionHeader___bG3Ga {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.BulkAssignPreview-module__viewToggle___Hs8Nq {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BulkAssignPreview-module__viewToggleLabel___a4We7 {
  font-size: 11px;
  color: #9ca3af;
}

.BulkAssignPreview-module__viewToggleBtn___ulL8o {
  font-size: 11px;
  padding: 2px 7px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
}

.BulkAssignPreview-module__viewToggleBtn___ulL8o:hover {
  color: #111827;
}

.BulkAssignPreview-module__viewToggleBtnActive___NxjC1 {
  background: #18181b;
  color: #f9fafb;
}

.BulkAssignPreview-module__emptyAssign___HmOjj {
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
  padding: 24px 0;
}

/* Group header */
.BulkAssignPreview-module__groupHeader___mf9bA {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 8px 4px;
  margin-top: 4px;
}

.BulkAssignPreview-module__groupLabel___B6qbT {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.BulkAssignPreview-module__groupCount___D3ZQ5 {
  font-size: 11px;
  color: #9ca3af;
}

/* Assignment row */
.BulkAssignPreview-module__assignRow____ycjP {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-bottom: 1px solid #f3f4f6;
}

.BulkAssignPreview-module__assignRow____ycjP:last-child {
  border-bottom: none;
}

.BulkAssignPreview-module__assignRowDimmed___tt4i6 {
  opacity: 0.45;
}

.BulkAssignPreview-module__assignRowCheck___Y9BMP {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #18181b;
  margin: 0;
}

.BulkAssignPreview-module__assignRowTitle___cXlKM {
  flex: 1;
  font-size: 12px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.BulkAssignPreview-module__assignRowMinutes___Q8qPi {
  font-size: 10px;
  font-family: monospace;
  color: #9ca3af;
  flex-shrink: 0;
}

.BulkAssignPreview-module__assignRowFrom____RuGq {
  font-size: 11px;
  color: #9ca3af;
  flex-shrink: 0;
  max-width: 90px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BulkAssignPreview-module__assignRowArrow___hZkzo {
  width: 12px;
  height: 12px;
  color: #d1d5db;
  flex-shrink: 0;
}

.BulkAssignPreview-module__assignRowSelect___TIXBK {
  font-size: 12px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  padding: 3px 6px;
  background: #ffffff;
  max-width: 150px;
  cursor: pointer;
  flex-shrink: 0;
}

.BulkAssignPreview-module__assignRowSelect___TIXBK:focus {
  outline: none;
  border-color: #9ca3af;
}

.BulkAssignPreview-module__assignRowMeta___RIO92 {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  min-width: 80px;
  justify-content: flex-end;
}

.BulkAssignPreview-module__assignRowMeta___RIO92 .BulkAssignPreview-module__slaBadge___lK04Z {
  font-size: 9px;
  padding: 1px 5px;
  white-space: nowrap;
}

.BulkAssignPreview-module__assignRowBadge___nmUee {
  font-size: 10px;
  font-weight: 500;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 1px 5px;
}

.BulkAssignPreview-module__assignRowWarning___mayHv {
  font-size: 10px;
  color: #92400e;
}

.BulkAssignPreview-module__pinButton___o9hHr {
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  color: #d1d5db;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.BulkAssignPreview-module__pinButton___o9hHr:hover:not(:disabled) {
  color: #6b7280;
}

.BulkAssignPreview-module__pinButton___o9hHr:disabled {
  cursor: default;
}

.BulkAssignPreview-module__pinButtonActive___B__OV {
  color: #111827;
}
.BulkAssignPreview-module__pinButtonActive___B__OV:disabled {
  color: #111827;
  opacity: 1;
}

.BulkAssignPreview-module__pinIcon___K6co9 {
  width: 12px;
  height: 12px;
}

/* Footer */
.BulkAssignPreview-module__footer___JbTJ6 {
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.BulkAssignPreview-module__cancelButton___AftAo {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #4b5563;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
}

.BulkAssignPreview-module__cancelButton___AftAo:hover {
  background: #f9fafb;
}

.BulkAssignPreview-module__applyButton___Tf7EQ {
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  background: #18181b;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.BulkAssignPreview-module__applyButton___Tf7EQ:hover:not(:disabled) {
  background: #27272a;
}

.BulkAssignPreview-module__applyButton___Tf7EQ:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/BulkAssignPreview/BulkAssignPreview.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA,WAAA;AACA;EACE,uBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA,oBAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA,kBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA,kBAAA;AACA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;;EAEE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA,wBAAA;AACA;EACE,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA,iBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA,mBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,SAAA;AACF;;AAEA;EACE,OAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;AACF;AACE;EACE,cAAA;EACA,UAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA,WAAA;AACA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;EACA,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AAAF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.card {\n  width: 100%;\n  max-width: 680px;\n  max-height: 90vh;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header */\n.header {\n  padding: 16px 20px 14px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.headerLeft {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.windowToggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.windowToggleBtn {\n  font-size: 13px;\n  font-weight: 500;\n  padding: 3px 10px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  background: #f9fafb;\n  color: #6b7280;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.windowToggleBtn:hover {\n  color: #111827;\n}\n\n.windowToggleBtnActive {\n  background: #ffffff;\n  color: #111827;\n  border-color: #e5e7eb;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.subtitle {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.subtitleMuted {\n  color: #9ca3af;\n}\n\n.rebalanceButton {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n  background: #f9fafb;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.rebalanceButton:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.rebalanceButton:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.rebalanceIcon {\n  width: 12px;\n  height: 12px;\n}\n\n/* Scrollable body */\n.body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* Section label */\n.sectionLabel {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #9ca3af;\n}\n\n/* Workload bars */\n.workloadSection {\n  padding: 14px 20px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.workloadHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.workloadHeaderLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.workloadBudgetLabel {\n  font-size: 10px;\n  font-family: monospace;\n  color: #9ca3af;\n}\n\n.workloadBadges {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.overCapBadge {\n  font-size: 11px;\n  font-weight: 600;\n  color: #92400e;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 4px;\n  padding: 2px 7px;\n}\n\n.slaBadge {\n  font-size: 11px;\n  font-weight: 600;\n  color: #b91c1c;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 4px;\n  padding: 2px 7px;\n}\n\n.workloadList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.workloadRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.workloadStaff {\n  width: 160px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.workloadAvatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.workloadStaffInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.workloadStaffName {\n  font-size: 12px;\n  font-weight: 500;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.workloadStaffRole {\n  font-size: 10px;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.workloadInlineBadges {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 3px;\n}\n\n.workloadInlineBadges .overCapBadge,\n.workloadInlineBadges .slaBadge {\n  font-size: 9px;\n  padding: 1px 5px;\n}\n\n.workloadBarWrap {\n  flex: 1;\n  height: 18px;\n  background: #f3f4f6;\n  border-radius: 3px;\n  overflow: hidden;\n  display: flex;\n  position: relative;\n}\n\n.workloadBarCurrent {\n  height: 100%;\n  background: #d1d5db;\n  flex-shrink: 0;\n}\n\n.workloadBarDelta {\n  height: 100%;\n  background: #18181b;\n  flex-shrink: 0;\n}\n\n.workloadBarDeltaOver {\n  height: 100%;\n  background: #d97706;\n  flex-shrink: 0;\n}\n\n.workloadBarDeltaSla {\n  height: 100%;\n  background: #b91c1c;\n  flex-shrink: 0;\n}\n\n.workloadCapacityMarker {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: rgba(107, 114, 128, 0.5);\n}\n\n.workloadNumbers {\n  width: 100px;\n  flex-shrink: 0;\n  text-align: right;\n  font-size: 11px;\n  font-family: monospace;\n  line-height: 1.4;\n}\n\n.workloadUtilPct {\n  font-size: 10px;\n  color: #9ca3af;\n}\n\n.workloadNum {\n  color: #6b7280;\n}\n\n.workloadNumOver {\n  color: #92400e;\n  font-weight: 600;\n}\n\n.workloadNumSla {\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.workloadNumDelta {\n  color: #18181b;\n  font-weight: 600;\n}\n\n/* Assignments section */\n.assignSection {\n  padding: 14px 20px 8px;\n}\n\n.assignSectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.viewToggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.viewToggleLabel {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.viewToggleBtn {\n  font-size: 11px;\n  padding: 2px 7px;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.viewToggleBtn:hover {\n  color: #111827;\n}\n\n.viewToggleBtnActive {\n  background: #18181b;\n  color: #f9fafb;\n}\n\n.emptyAssign {\n  font-size: 13px;\n  color: #9ca3af;\n  text-align: center;\n  padding: 24px 0;\n}\n\n/* Group header */\n.groupHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 8px 4px;\n  margin-top: 4px;\n}\n\n.groupLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.groupCount {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* Assignment row */\n.assignRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 8px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.assignRow:last-child {\n  border-bottom: none;\n}\n\n.assignRowDimmed {\n  opacity: 0.45;\n}\n\n.assignRowCheck {\n  width: 13px;\n  height: 13px;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #18181b;\n  margin: 0;\n}\n\n.assignRowTitle {\n  flex: 1;\n  font-size: 12px;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.assignRowMinutes {\n  font-size: 10px;\n  font-family: monospace;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.assignRowFrom {\n  font-size: 11px;\n  color: #9ca3af;\n  flex-shrink: 0;\n  max-width: 90px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.assignRowArrow {\n  width: 12px;\n  height: 12px;\n  color: #d1d5db;\n  flex-shrink: 0;\n}\n\n.assignRowSelect {\n  font-size: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 5px;\n  padding: 3px 6px;\n  background: #ffffff;\n  max-width: 150px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.assignRowSelect:focus {\n  outline: none;\n  border-color: #9ca3af;\n}\n\n.assignRowMeta {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  min-width: 80px;\n  justify-content: flex-end;\n}\n\n.assignRowMeta .slaBadge {\n  font-size: 9px;\n  padding: 1px 5px;\n  white-space: nowrap;\n}\n\n.assignRowBadge {\n  font-size: 10px;\n  font-weight: 500;\n  color: #6b7280;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  padding: 1px 5px;\n}\n\n.assignRowWarning {\n  font-size: 10px;\n  color: #92400e;\n}\n\n.pinButton {\n  padding: 4px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: 4px;\n  color: #d1d5db;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.pinButton:hover:not(:disabled) {\n  color: #6b7280;\n}\n\n.pinButton:disabled {\n  cursor: default;\n}\n\n.pinButtonActive {\n  color: #111827;\n\n  &:disabled {\n    color: #111827;\n    opacity: 1;\n  }\n}\n\n.pinIcon {\n  width: 12px;\n  height: 12px;\n}\n\n/* Footer */\n.footer {\n  padding: 12px 20px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.cancelButton {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #4b5563;\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.cancelButton:hover {\n  background: #f9fafb;\n}\n\n.applyButton {\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  background: #18181b;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.applyButton:hover:not(:disabled) {\n  background: #27272a;\n}\n\n.applyButton:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `BulkAssignPreview-module__overlay___J_azi`,
	"card": `BulkAssignPreview-module__card___ZU7Xa`,
	"header": `BulkAssignPreview-module__header___mjpkH`,
	"headerLeft": `BulkAssignPreview-module__headerLeft___q8Qqi`,
	"windowToggle": `BulkAssignPreview-module__windowToggle___zl3i4`,
	"windowToggleBtn": `BulkAssignPreview-module__windowToggleBtn___Ww38L`,
	"windowToggleBtnActive": `BulkAssignPreview-module__windowToggleBtnActive___qPc2I`,
	"title": `BulkAssignPreview-module__title___BaROp`,
	"subtitle": `BulkAssignPreview-module__subtitle___tjbtE`,
	"subtitleMuted": `BulkAssignPreview-module__subtitleMuted___gpiEA`,
	"rebalanceButton": `BulkAssignPreview-module__rebalanceButton___Z9DJ9`,
	"rebalanceIcon": `BulkAssignPreview-module__rebalanceIcon___sdFjW`,
	"body": `BulkAssignPreview-module__body___JzLcQ`,
	"sectionLabel": `BulkAssignPreview-module__sectionLabel___E3UBS`,
	"workloadSection": `BulkAssignPreview-module__workloadSection___PlhlF`,
	"workloadHeader": `BulkAssignPreview-module__workloadHeader___VKeRe`,
	"workloadHeaderLeft": `BulkAssignPreview-module__workloadHeaderLeft___Vb3K5`,
	"workloadBudgetLabel": `BulkAssignPreview-module__workloadBudgetLabel___pvdmv`,
	"workloadBadges": `BulkAssignPreview-module__workloadBadges___Tu4Aw`,
	"overCapBadge": `BulkAssignPreview-module__overCapBadge___JkGz4`,
	"slaBadge": `BulkAssignPreview-module__slaBadge___lK04Z`,
	"workloadList": `BulkAssignPreview-module__workloadList___KCNqU`,
	"workloadRow": `BulkAssignPreview-module__workloadRow___IE5Dx`,
	"workloadStaff": `BulkAssignPreview-module__workloadStaff___D3Jq8`,
	"workloadAvatar": `BulkAssignPreview-module__workloadAvatar___oHjoJ`,
	"workloadStaffInfo": `BulkAssignPreview-module__workloadStaffInfo___VvEh1`,
	"workloadStaffName": `BulkAssignPreview-module__workloadStaffName___neinv`,
	"workloadStaffRole": `BulkAssignPreview-module__workloadStaffRole___PiGmv`,
	"workloadInlineBadges": `BulkAssignPreview-module__workloadInlineBadges___GuxkL`,
	"workloadBarWrap": `BulkAssignPreview-module__workloadBarWrap___FTTVc`,
	"workloadBarCurrent": `BulkAssignPreview-module__workloadBarCurrent___JLv2W`,
	"workloadBarDelta": `BulkAssignPreview-module__workloadBarDelta___BtFFm`,
	"workloadBarDeltaOver": `BulkAssignPreview-module__workloadBarDeltaOver___kh953`,
	"workloadBarDeltaSla": `BulkAssignPreview-module__workloadBarDeltaSla___QsOPM`,
	"workloadCapacityMarker": `BulkAssignPreview-module__workloadCapacityMarker___a9DgA`,
	"workloadNumbers": `BulkAssignPreview-module__workloadNumbers___USvrx`,
	"workloadUtilPct": `BulkAssignPreview-module__workloadUtilPct___jPXuu`,
	"workloadNum": `BulkAssignPreview-module__workloadNum___rk388`,
	"workloadNumOver": `BulkAssignPreview-module__workloadNumOver___egiDL`,
	"workloadNumSla": `BulkAssignPreview-module__workloadNumSla___HdgDt`,
	"workloadNumDelta": `BulkAssignPreview-module__workloadNumDelta___egR4y`,
	"assignSection": `BulkAssignPreview-module__assignSection___RYycu`,
	"assignSectionHeader": `BulkAssignPreview-module__assignSectionHeader___bG3Ga`,
	"viewToggle": `BulkAssignPreview-module__viewToggle___Hs8Nq`,
	"viewToggleLabel": `BulkAssignPreview-module__viewToggleLabel___a4We7`,
	"viewToggleBtn": `BulkAssignPreview-module__viewToggleBtn___ulL8o`,
	"viewToggleBtnActive": `BulkAssignPreview-module__viewToggleBtnActive___NxjC1`,
	"emptyAssign": `BulkAssignPreview-module__emptyAssign___HmOjj`,
	"groupHeader": `BulkAssignPreview-module__groupHeader___mf9bA`,
	"groupLabel": `BulkAssignPreview-module__groupLabel___B6qbT`,
	"groupCount": `BulkAssignPreview-module__groupCount___D3ZQ5`,
	"assignRow": `BulkAssignPreview-module__assignRow____ycjP`,
	"assignRowDimmed": `BulkAssignPreview-module__assignRowDimmed___tt4i6`,
	"assignRowCheck": `BulkAssignPreview-module__assignRowCheck___Y9BMP`,
	"assignRowTitle": `BulkAssignPreview-module__assignRowTitle___cXlKM`,
	"assignRowMinutes": `BulkAssignPreview-module__assignRowMinutes___Q8qPi`,
	"assignRowFrom": `BulkAssignPreview-module__assignRowFrom____RuGq`,
	"assignRowArrow": `BulkAssignPreview-module__assignRowArrow___hZkzo`,
	"assignRowSelect": `BulkAssignPreview-module__assignRowSelect___TIXBK`,
	"assignRowMeta": `BulkAssignPreview-module__assignRowMeta___RIO92`,
	"assignRowBadge": `BulkAssignPreview-module__assignRowBadge___nmUee`,
	"assignRowWarning": `BulkAssignPreview-module__assignRowWarning___mayHv`,
	"pinButton": `BulkAssignPreview-module__pinButton___o9hHr`,
	"pinButtonActive": `BulkAssignPreview-module__pinButtonActive___B__OV`,
	"pinIcon": `BulkAssignPreview-module__pinIcon___K6co9`,
	"footer": `BulkAssignPreview-module__footer___JbTJ6`,
	"cancelButton": `BulkAssignPreview-module__cancelButton___AftAo`,
	"applyButton": `BulkAssignPreview-module__applyButton___Tf7EQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
